export default {
	backendUrl: process.env.VUE_APP_API_URL,
	baseUrl: process.env.VUE_APP_BASE_URL,
	env: process.env.VUE_APP_CDN_ENV,
	webUrl: process.env.VUE_APP_WEB_URL
};
